import { render, staticRenderFns } from "./avatars-list.vue?vue&type=template&id=4894b38a"
import script from "./avatars-list.vue?vue&type=script&lang=js"
export * from "./avatars-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports